import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Leaf, CaretRight, MagnifyingGlass, Wine, MapPin } from '@phosphor-icons/react';

const GrapeVarietiesOverviewPage = () => {
  const [selectedLetter, setSelectedLetter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  // Comprehensive list of grape varieties
  const grapeVarieties = [
    // A
    { name: 'Aglianico', country: 'Italie', type: 'Rouge', region: 'Campanie', characteristics: 'Puissant, tanins fermes, notes de prune' },
    { name: 'Albariño', country: 'Espagne', type: 'Blanc', region: 'Galice', characteristics: 'Aromatique, minéral, acidité vive' },
    { name: 'Albarossa', country: 'Italie', type: 'Rouge', region: 'Piémont', characteristics: 'Structuré, fruits noirs, épices' },
    { name: 'Aleatico', country: 'Italie', type: 'Rouge', region: 'Toscane', characteristics: 'Doux, aromatique, notes de rose' },
    { name: 'Alfrocheiro', country: 'Portugal', type: 'Rouge', region: 'Dão', characteristics: 'Fruité, tanins doux, structure légère' },
    { name: 'Alicante Bouschet', country: 'France', type: 'Rouge', region: 'Languedoc', characteristics: 'Teinturier, couleur intense, fruits noirs' },
    { name: 'Aligoté', country: 'France', type: 'Blanc', region: 'Bourgogne', characteristics: 'Sec, acidité vive, notes d\'agrumes' },
    { name: 'Altesse', country: 'France', type: 'Blanc', region: 'Savoie', characteristics: 'Aromatique, fleurs blanches, acidité vive' },
    { name: 'Alvarinho', country: 'Portugal', type: 'Blanc', region: 'Vinho Verde', characteristics: 'Aromatique, frais, notes d\'agrumes' },
    { name: 'Antão Vaz', country: 'Portugal', type: 'Blanc', region: 'Alentejo', characteristics: 'Riche, beurre, notes de fruits tropicaux' },
    { name: 'Arinto', country: 'Portugal', type: 'Blanc', region: 'Lisboa', characteristics: 'Acidité vive, minéral, notes d\'agrumes' },
    { name: 'Arneis', country: 'Italie', type: 'Blanc', region: 'Piémont', characteristics: 'Sec, aromatique, notes de poire' },
    { name: 'Assyrtiko', country: 'Grèce', type: 'Blanc', region: 'Santorin', characteristics: 'Minéral, acidité élevée, notes citronnées' },
    { name: 'Auxerrois', country: 'France', type: 'Blanc', region: 'Alsace', characteristics: 'Doux, aromatique, notes de fruits blancs' },
    
    // B
    { name: 'Bacchus', country: 'Allemagne', type: 'Blanc', region: 'Rheinhessen', characteristics: 'Aromatique, muscat, notes florales' },
    { name: 'Baga', country: 'Portugal', type: 'Rouge', region: 'Bairrada', characteristics: 'Tanins fermes, structure, notes de fruits noirs' },
    { name: 'Barbera', country: 'Italie', type: 'Rouge', region: 'Piémont', characteristics: 'Acidité vive, fruits rouges, tanins doux' },
    { name: 'Bastardo', country: 'Portugal', type: 'Rouge', region: 'Douro', characteristics: 'Élégant, fruits rouges, structure légère' },
    { name: 'Bical', country: 'Portugal', type: 'Blanc', region: 'Bairrada', characteristics: 'Acidité vive, minéral, notes d\'agrumes' },
    { name: 'Blaufränkisch', country: 'Autriche', type: 'Rouge', region: 'Burgenland', characteristics: 'Élégant, épices, notes de cerise' },
    { name: 'Bobal', country: 'Espagne', type: 'Rouge', region: 'Utiel-Requena', characteristics: 'Fruité, tanins doux, structure moyenne' },
    { name: 'Bonarda', country: 'Argentine', type: 'Rouge', region: 'Mendoza', characteristics: 'Fruité, doux, tanins souples' },
    { name: 'Bourboulenc', country: 'France', type: 'Blanc', region: 'Languedoc', characteristics: 'Sec, minéral, acidité vive' },
    { name: 'Brachetto', country: 'Italie', type: 'Rouge', region: 'Piémont', characteristics: 'Doux, aromatique, notes de fraise' },
    { name: 'Brunello', country: 'Italie', type: 'Rouge', region: 'Toscane', characteristics: 'Structuré, tanins fermes, notes de cerise' },
    
    // C
    { name: 'Cabernet Franc', country: 'France', type: 'Rouge', region: 'Loire', characteristics: 'Herbacé, poivré, fruits rouges' },
    { name: 'Cabernet Sauvignon', country: 'France', type: 'Rouge', region: 'Bordeaux', characteristics: 'Structuré, tanins fermes, cassis' },
    { name: 'Cannonau', country: 'Italie', type: 'Rouge', region: 'Sardaigne', characteristics: 'Puissant, épices, alcool élevé' },
    { name: 'Carignan', country: 'France', type: 'Rouge', region: 'Languedoc', characteristics: 'Puissant, fruits noirs, épices' },
    { name: 'Carmenère', country: 'Chili', type: 'Rouge', region: 'Maipo', characteristics: 'Herbacé, poivré, fruits mûrs' },
    { name: 'Carricante', country: 'Italie', type: 'Blanc', region: 'Sicile', characteristics: 'Minéral, acidité vive, notes d\'agrumes' },
    { name: 'Castelão', country: 'Portugal', type: 'Rouge', region: 'Lisboa', characteristics: 'Fruité, tanins doux, structure légère' },
    { name: 'Catarratto', country: 'Italie', type: 'Blanc', region: 'Sicile', characteristics: 'Neutre, acidité modérée, notes d\'agrumes' },
    { name: 'Cesanese', country: 'Italie', type: 'Rouge', region: 'Latium', characteristics: 'Élégant, fruits rouges, tanins doux' },
    { name: 'Chardonnay', country: 'France', type: 'Blanc', region: 'Bourgogne', characteristics: 'Polyvalent, beurre, fruits blancs' },
    { name: 'Chenin Blanc', country: 'France', type: 'Blanc', region: 'Loire', characteristics: 'Acidité vive, miel, fruits secs' },
    { name: 'Cinsault', country: 'France', type: 'Rouge', region: 'Provence', characteristics: 'Fruité, doux, tanins souples' },
    { name: 'Clairette', country: 'France', type: 'Blanc', region: 'Rhône', characteristics: 'Sec, neutre, acidité modérée' },
    { name: 'Colombard', country: 'France', type: 'Blanc', region: 'Gascogne', characteristics: 'Sec, aromatique, notes d\'agrumes' },
    { name: 'Corvina', country: 'Italie', type: 'Rouge', region: 'Vénétie', characteristics: 'Fruité, cerise, structure légère' },
    { name: 'Cortese', country: 'Italie', type: 'Blanc', region: 'Piémont', characteristics: 'Sec, minéral, acidité vive' },
    { name: 'Counoise', country: 'France', type: 'Rouge', region: 'Rhône', characteristics: 'Fruité, épices, structure légère' },
    { name: 'Criolla Grande', country: 'Argentine', type: 'Rouge', region: 'Mendoza', characteristics: 'Fruité, doux, tanins souples' },
    { name: 'Croatina', country: 'Italie', type: 'Rouge', region: 'Lombardie', characteristics: 'Fruité, tanins modérés, notes de prune' },
    
    // D
    { name: 'Dolcetto', country: 'Italie', type: 'Rouge', region: 'Piémont', characteristics: 'Fruité, doux, tanins doux' },
    { name: 'Dornfelder', country: 'Allemagne', type: 'Rouge', region: 'Pfalz', characteristics: 'Fruité, tanins doux, notes de cerise' },
    
    // E
    { name: 'Encruzado', country: 'Portugal', type: 'Blanc', region: 'Dão', characteristics: 'Élégant, minéral, notes florales' },
    { name: 'Erbaluce', country: 'Italie', type: 'Blanc', region: 'Piémont', characteristics: 'Sec, aromatique, notes de poire' },
    
    // F
    { name: 'Falanghina', country: 'Italie', type: 'Blanc', region: 'Campanie', characteristics: 'Aromatique, fleurs blanches, acidité vive' },
    { name: 'Fernão Pires', country: 'Portugal', type: 'Blanc', region: 'Lisboa', characteristics: 'Aromatique, muscat, notes florales' },
    { name: 'Fiano', country: 'Italie', type: 'Blanc', region: 'Campanie', characteristics: 'Aromatique, miel, notes d\'amande' },
    { name: 'Folle Blanche', country: 'France', type: 'Blanc', region: 'Cognac', characteristics: 'Sec, acidité vive, notes d\'agrumes' },
    { name: 'Freisa', country: 'Italie', type: 'Rouge', region: 'Piémont', characteristics: 'Fruité, acidité vive, notes de fraise' },
    { name: 'Furmint', country: 'Hongrie', type: 'Blanc', region: 'Tokaj', characteristics: 'Acidité élevée, notes d\'agrumes' },
    
    // G
    { name: 'Gaglioppo', country: 'Italie', type: 'Rouge', region: 'Calabre', characteristics: 'Puissant, tanins fermes, notes de prune' },
    { name: 'Gamay', country: 'France', type: 'Rouge', region: 'Beaujolais', characteristics: 'Fruité, frais, tanins doux' },
    { name: 'Garganega', country: 'Italie', type: 'Blanc', region: 'Vénétie', characteristics: 'Sec, aromatique, notes d\'amande' },
    { name: 'Garnacha', country: 'Espagne', type: 'Rouge', region: 'Rioja', characteristics: 'Fruité, épices, structure moyenne' },
    { name: 'Gewürztraminer', country: 'France', type: 'Blanc', region: 'Alsace', characteristics: 'Aromatique, lychee, épices' },
    { name: 'Godello', country: 'Espagne', type: 'Blanc', region: 'Galice', characteristics: 'Élégant, minéral, notes d\'agrumes' },
    { name: 'Graciano', country: 'Espagne', type: 'Rouge', region: 'Rioja', characteristics: 'Structure, tanins fermes, notes de violette' },
    { name: 'Grenache', country: 'France', type: 'Rouge', region: 'Rhône', characteristics: 'Fruité, épices, alcool élevé' },
    { name: 'Grillo', country: 'Italie', type: 'Blanc', region: 'Sicile', characteristics: 'Sec, aromatique, notes d\'agrumes' },
    { name: 'Grüner Veltliner', country: 'Autriche', type: 'Blanc', region: 'Niederösterreich', characteristics: 'Poivré, acidité vive, minéral' },
    
    // H
    { name: 'Hárslevelű', country: 'Hongrie', type: 'Blanc', region: 'Tokaj', characteristics: 'Aromatique, miel, notes florales' },
    
    // I
    { name: 'Inzolia', country: 'Italie', type: 'Blanc', region: 'Sicile', characteristics: 'Sec, neutre, acidité modérée' },
    
    // J
    { name: 'Jaén', country: 'Espagne', type: 'Rouge', region: 'Andalousie', characteristics: 'Fruité, tanins doux, structure légère' },
    
    // K
    { name: 'Kerner', country: 'Allemagne', type: 'Blanc', region: 'Pfalz', characteristics: 'Aromatique, riesling, notes florales' },
    
    // L
    { name: 'Lagrein', country: 'Italie', type: 'Rouge', region: 'Trentin', characteristics: 'Puissant, tanins fermes, notes de violette' },
    { name: 'Lambrusco', country: 'Italie', type: 'Rouge', region: 'Émilie-Romagne', characteristics: 'Effervescent, fruité, doux' },
    { name: 'Loureiro', country: 'Portugal', type: 'Blanc', region: 'Vinho Verde', characteristics: 'Aromatique, fleurs blanches, acidité vive' },
    
    // M
    { name: 'Macabeo', country: 'Espagne', type: 'Blanc', region: 'Catalogne', characteristics: 'Sec, neutre, acidité modérée' },
    { name: 'Malbec', country: 'Argentine', type: 'Rouge', region: 'Mendoza', characteristics: 'Fruité, tanins doux, notes de prune' },
    { name: 'Malvasia', country: 'Italie', type: 'Blanc', region: 'Sicile', characteristics: 'Aromatique, muscat, notes florales' },
    { name: 'Manseng', country: 'France', type: 'Blanc', region: 'Jurançon', characteristics: 'Aromatique, acidité vive, notes d\'agrumes' },
    { name: 'Mencía', country: 'Espagne', type: 'Rouge', region: 'Bierzo', characteristics: 'Élégant, fruits rouges, épices' },
    { name: 'Merlot', country: 'France', type: 'Rouge', region: 'Bordeaux', characteristics: 'Fruité, tanins doux, structure équilibrée' },
    { name: 'Monastrell', country: 'Espagne', type: 'Rouge', region: 'Murcie', characteristics: 'Puissant, tanins fermes, notes de prune' },
    { name: 'Montepulciano', country: 'Italie', type: 'Rouge', region: 'Abruzzes', characteristics: 'Fruité, tanins modérés, notes de prune' },
    { name: 'Mourvèdre', country: 'France', type: 'Rouge', region: 'Provence', characteristics: 'Puissant, épices, notes de gibier' },
    { name: 'Müller-Thurgau', country: 'Allemagne', type: 'Blanc', region: 'Rheinhessen', characteristics: 'Fruité, doux, notes florales' },
    { name: 'Muscadelle', country: 'France', type: 'Blanc', region: 'Bordeaux', characteristics: 'Aromatique, muscat, notes florales' },
    { name: 'Muscat', country: 'France', type: 'Blanc', region: 'Alsace', characteristics: 'Aromatique, muscat, notes florales' },
    
    // N
    { name: 'Nebbiolo', country: 'Italie', type: 'Rouge', region: 'Piémont', characteristics: 'Structuré, tanins fermes, notes de rose' },
    { name: 'Negroamaro', country: 'Italie', type: 'Rouge', region: 'Pouilles', characteristics: 'Puissant, tanins fermes, notes de prune' },
    { name: 'Nero d\'Avola', country: 'Italie', type: 'Rouge', region: 'Sicile', characteristics: 'Puissant, fruits noirs, épices' },
    { name: 'Nerello Mascalese', country: 'Italie', type: 'Rouge', region: 'Sicile', characteristics: 'Élégant, acidité vive, notes de cerise' },
    { name: 'Nerello Cappuccio', country: 'Italie', type: 'Rouge', region: 'Sicile', characteristics: 'Fruité, tanins doux, structure légère' },
    
    // O
    { name: 'Oseleta', country: 'Italie', type: 'Rouge', region: 'Vénétie', characteristics: 'Structuré, tanins fermes, notes de fruits noirs' },
    
    // P
    { name: 'Palomino', country: 'Espagne', type: 'Blanc', region: 'Andalousie', characteristics: 'Neutre, sec, acidité modérée' },
    { name: 'Parellada', country: 'Espagne', type: 'Blanc', region: 'Catalogne', characteristics: 'Sec, aromatique, notes d\'agrumes' },
    { name: 'Pedro Ximénez', country: 'Espagne', type: 'Blanc', region: 'Andalousie', characteristics: 'Doux, raisins secs, notes de figue' },
    { name: 'Petit Manseng', country: 'France', type: 'Blanc', region: 'Jurançon', characteristics: 'Aromatique, acidité vive, notes d\'agrumes' },
    { name: 'Petit Verdot', country: 'France', type: 'Rouge', region: 'Bordeaux', characteristics: 'Puissant, tanins fermes, notes de violette' },
    { name: 'Picpoul', country: 'France', type: 'Blanc', region: 'Languedoc', characteristics: 'Sec, acidité vive, notes d\'agrumes' },
    { name: 'Pinot Blanc', country: 'France', type: 'Blanc', region: 'Alsace', characteristics: 'Sec, neutre, acidité modérée' },
    { name: 'Pinot Grigio', country: 'Italie', type: 'Blanc', region: 'Vénétie', characteristics: 'Sec, neutre, acidité modérée' },
    { name: 'Pinot Meunier', country: 'France', type: 'Rouge', region: 'Champagne', characteristics: 'Fruité, doux, tanins souples' },
    { name: 'Pinot Noir', country: 'France', type: 'Rouge', region: 'Bourgogne', characteristics: 'Élégant, fruits rouges, tanins doux' },
    { name: 'Piquepoul', country: 'France', type: 'Blanc', region: 'Languedoc', characteristics: 'Sec, acidité vive, notes d\'agrumes' },
    { name: 'Poulsard', country: 'France', type: 'Rouge', region: 'Jura', characteristics: 'Léger, fruits rouges, acidité vive' },
    { name: 'Primitivo', country: 'Italie', type: 'Rouge', region: 'Pouilles', characteristics: 'Fruité, alcool élevé, notes de prune' },
    { name: 'Prosecco', country: 'Italie', type: 'Blanc', region: 'Vénétie', characteristics: 'Effervescent, fruité, doux' },
    
    // Q
    { name: 'Quebranta', country: 'Pérou', type: 'Blanc', region: 'Ica', characteristics: 'Neutre, sec, acidité modérée' },
    
    // R
    { name: 'Refosco', country: 'Italie', type: 'Rouge', region: 'Frioul', characteristics: 'Puissant, tanins fermes, notes de prune' },
    { name: 'Riesling', country: 'Allemagne', type: 'Blanc', region: 'Mosel', characteristics: 'Aromatique, acidité vive, minéral' },
    { name: 'Rondinella', country: 'Italie', type: 'Rouge', region: 'Vénétie', characteristics: 'Fruité, structure légère, notes de cerise' },
    { name: 'Roussanne', country: 'France', type: 'Blanc', region: 'Rhône', characteristics: 'Riche, beurre, notes de fruits tropicaux' },
    
    // S
    { name: 'Sagrantino', country: 'Italie', type: 'Rouge', region: 'Ombrie', characteristics: 'Puissant, tanins très fermes, notes de prune' },
    { name: 'Sangiovese', country: 'Italie', type: 'Rouge', region: 'Toscane', characteristics: 'Acidité vive, tanins fermes, notes de cerise' },
    { name: 'Sauvignon Blanc', country: 'France', type: 'Blanc', region: 'Loire', characteristics: 'Herbacé, acidité vive, notes d\'agrumes' },
    { name: 'Savagnin', country: 'France', type: 'Blanc', region: 'Jura', characteristics: 'Oxydatif, noix, notes d\'amande' },
    { name: 'Scheurebe', country: 'Allemagne', type: 'Blanc', region: 'Pfalz', characteristics: 'Aromatique, muscat, notes de cassis' },
    { name: 'Sémillon', country: 'France', type: 'Blanc', region: 'Bordeaux', characteristics: 'Riche, miel, notes de fruits secs' },
    { name: 'Shiraz', country: 'Australie', type: 'Rouge', region: 'Barossa Valley', characteristics: 'Puissant, épices, fruits noirs' },
    { name: 'Silvaner', country: 'Allemagne', type: 'Blanc', region: 'Franconie', characteristics: 'Neutre, minéral, acidité modérée' },
    { name: 'Syrah', country: 'France', type: 'Rouge', region: 'Rhône', characteristics: 'Puissant, épices, notes de poivre' },
    
    // T
    { name: 'Tannat', country: 'France', type: 'Rouge', region: 'Madiran', characteristics: 'Puissant, tanins très fermes, structure imposante' },
    { name: 'Tempranillo', country: 'Espagne', type: 'Rouge', region: 'Rioja', characteristics: 'Élégant, tanins modérés, notes de vanille' },
    { name: 'Teroldego', country: 'Italie', type: 'Rouge', region: 'Trentin', characteristics: 'Puissant, tanins fermes, notes de prune' },
    { name: 'Torrontés', country: 'Argentine', type: 'Blanc', region: 'Salta', characteristics: 'Aromatique, fleurs blanches, acidité vive' },
    { name: 'Touriga Franca', country: 'Portugal', type: 'Rouge', region: 'Douro', characteristics: 'Élégant, tanins modérés, notes florales' },
    { name: 'Touriga Nacional', country: 'Portugal', type: 'Rouge', region: 'Douro', characteristics: 'Puissant, tanins fermes, notes florales' },
    { name: 'Traminer', country: 'France', type: 'Blanc', region: 'Alsace', characteristics: 'Aromatique, muscat, notes florales' },
    { name: 'Trebbiano', country: 'Italie', type: 'Blanc', region: 'Toscane', characteristics: 'Sec, neutre, acidité modérée' },
    { name: 'Trousseau', country: 'France', type: 'Rouge', region: 'Jura', characteristics: 'Élégant, fruits rouges, épices' },
    
    // U
    { name: 'Ugni Blanc', country: 'France', type: 'Blanc', region: 'Cognac', characteristics: 'Sec, acidité vive, notes d\'agrumes' },
    
    // V
    { name: 'Verdejo', country: 'Espagne', type: 'Blanc', region: 'Rueda', characteristics: 'Aromatique, herbe, notes d\'agrumes' },
    { name: 'Verdejo Negro', country: 'Espagne', type: 'Rouge', region: 'Canaries', characteristics: 'Fruité, tanins doux, structure légère' },
    { name: 'Vermentino', country: 'Italie', type: 'Blanc', region: 'Sardaigne', characteristics: 'Aromatique, herbe, notes d\'agrumes' },
    { name: 'Vernaccia', country: 'Italie', type: 'Blanc', region: 'Toscane', characteristics: 'Sec, minéral, acidité vive' },
    { name: 'Viognier', country: 'France', type: 'Blanc', region: 'Rhône', characteristics: 'Aromatique, pêche, notes florales' },
    { name: 'Viosinho', country: 'Portugal', type: 'Blanc', region: 'Douro', characteristics: 'Aromatique, fleurs blanches, acidité vive' },
    
    // W
    { name: 'Weissburgunder', country: 'Autriche', type: 'Blanc', region: 'Niederösterreich', characteristics: 'Sec, neutre, acidité modérée' },
    
    // X
    { name: 'Xarel-lo', country: 'Espagne', type: 'Blanc', region: 'Catalogne', characteristics: 'Sec, aromatique, notes d\'agrumes' },
    
    // Z
    { name: 'Zinfandel', country: 'États-Unis', type: 'Rouge', region: 'Californie', characteristics: 'Fruité, alcool élevé, notes de prune' },
    { name: 'Zweigelt', country: 'Autriche', type: 'Rouge', region: 'Burgenland', characteristics: 'Fruité, cerise, tanins doux' }
  ];

  // Grape variety categories
  const grapeCategories = [
    {
      name: 'Cépages Rouges',
      description: 'Cépages pour vins rouges et rosés',
      icon: <Wine size={24} color="#4B164C" weight="light" />,
      varieties: grapeVarieties.filter(g => g.type === 'Rouge')
    },
    {
      name: 'Cépages Blancs',
      description: 'Cépages pour vins blancs',
      icon: <Leaf size={24} color="#4B164C" weight="light" />,
      varieties: grapeVarieties.filter(g => g.type === 'Blanc')
    }
  ];

  // Wine style characteristics
  const wineStyles = [
    {
      name: 'Cépages Aromatiques',
      description: 'Cépages avec des arômes intenses et distinctifs',
      examples: ['Gewürztraminer', 'Viognier', 'Torrontés', 'Riesling'],
      characteristics: 'Arômes floraux, fruits exotiques, épices'
    },
    {
      name: 'Cépages Structurés',
      description: 'Cépages avec des tanins fermes et une structure imposante',
      examples: ['Cabernet Sauvignon', 'Nebbiolo', 'Sangiovese', 'Touriga Nacional'],
      characteristics: 'Tanins fermes, structure, potentiel de garde'
    },
    {
      name: 'Cépages Élégants',
      description: 'Cépages avec une finesse et une élégance particulières',
      examples: ['Pinot Noir', 'Nebbiolo', 'Tempranillo', 'Mencía'],
      characteristics: 'Finesse, élégance, complexité aromatique'
    },
    {
      name: 'Cépages Fruités',
      description: 'Cépages avec des arômes de fruits dominants',
      examples: ['Merlot', 'Gamay', 'Grenache', 'Malbec'],
      characteristics: 'Fruits rouges/noirs, douceur, accessibilité'
    }
  ];

  // Generate alphabet for filter
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  // Filter grape varieties based on search and letter selection
  const getFilteredVarieties = () => {
    return grapeVarieties.filter(grape => {
      const matchesSearch = grape.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                           grape.country.toLowerCase().includes(searchTerm.toLowerCase()) ||
                           grape.region.toLowerCase().includes(searchTerm.toLowerCase()) ||
                           grape.characteristics.toLowerCase().includes(searchTerm.toLowerCase());
      
      const matchesLetter = selectedLetter === 'all' || 
                           grape.name.toUpperCase().startsWith(selectedLetter);
      
      return matchesSearch && matchesLetter;
    });
  };

  const filteredVarieties = getFilteredVarieties();

  // Group filtered varieties by first letter
  const groupedVarieties = filteredVarieties.reduce((groups, grape) => {
    const firstLetter = grape.name.charAt(0).toUpperCase();
    if (!groups[firstLetter]) {
      groups[firstLetter] = [];
    }
    groups[firstLetter].push(grape);
    return groups;
  }, {});

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <h1 style={{ 
          fontSize: '2.5rem', 
          color: '#4B164C', 
          marginBottom: '10px',
          fontWeight: '700'
        }}>
          Cépages du Monde
        </h1>
        <p style={{ 
          fontSize: '1.2rem', 
          color: '#666', 
          maxWidth: '700px', 
          margin: '0 auto',
          lineHeight: '1.6'
        }}>
          Découvrez tous les cépages, leurs caractéristiques et leurs régions d'origine
        </p>
      </div>

      {/* Search and Filter */}
      <div style={{ 
        display: 'flex', 
        flexWrap: 'wrap', 
        gap: '15px', 
        marginBottom: '30px',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{ position: 'relative' }}>
          <MagnifyingGlass 
            size={20} 
            color="#666" 
            style={{ 
              position: 'absolute', 
              left: '12px', 
              top: '50%', 
              transform: 'translateY(-50%)' 
            }} 
          />
          <input
            type="text"
            placeholder="Rechercher un cépage, pays ou région..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              padding: '12px 12px 12px 40px',
              border: '2px solid #e8e0e8',
              borderRadius: '8px',
              fontSize: '1rem',
              width: '300px',
              outline: 'none'
            }}
            onFocus={e => e.target.style.borderColor = '#4B164C'}
            onBlur={e => e.target.style.borderColor = '#e8e0e8'}
          />
        </div>
        
        <select
          value={selectedLetter}
          onChange={(e) => setSelectedLetter(e.target.value)}
          style={{
            padding: '12px',
            border: '2px solid #e8e0e8',
            borderRadius: '8px',
            fontSize: '1rem',
            background: 'white',
            outline: 'none'
          }}
        >
          <option value="all">Toutes les lettres</option>
          {alphabet.map(letter => (
            <option key={letter} value={letter}>
              {letter}
            </option>
          ))}
        </select>
      </div>

      {/* Alphabetical Index */}
      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          fontSize: '1.2rem', 
          color: '#4B164C', 
          marginBottom: '15px',
          textAlign: 'center',
          fontWeight: '600'
        }}>
          Index Alphabétique
        </h3>
        <div style={{ 
          display: 'flex', 
          flexWrap: 'wrap', 
          gap: '8px', 
          justifyContent: 'center' 
        }}>
          <button
            onClick={() => setSelectedLetter('all')}
            style={{
              padding: '8px 12px',
              border: selectedLetter === 'all' ? '2px solid #4B164C' : '2px solid #e8e0e8',
              borderRadius: '6px',
              background: selectedLetter === 'all' ? '#4B164C' : 'white',
              color: selectedLetter === 'all' ? 'white' : '#4B164C',
              fontSize: '0.9rem',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseOver={e => {
              if (selectedLetter !== 'all') {
                e.currentTarget.style.borderColor = '#4B164C';
                e.currentTarget.style.background = '#f0e6f0';
              }
            }}
            onMouseOut={e => {
              if (selectedLetter !== 'all') {
                e.currentTarget.style.borderColor = '#e8e0e8';
                e.currentTarget.style.background = 'white';
              }
            }}
          >
            Tous
          </button>
          {alphabet.map(letter => {
            const hasVarieties = grapeVarieties.some(g => g.name.toUpperCase().startsWith(letter));
            return (
              <button
                key={letter}
                onClick={() => setSelectedLetter(letter)}
                disabled={!hasVarieties}
                style={{
                  padding: '8px 12px',
                  border: selectedLetter === letter ? '2px solid #4B164C' : '2px solid #e8e0e8',
                  borderRadius: '6px',
                  background: selectedLetter === letter ? '#4B164C' : (hasVarieties ? 'white' : '#f5f5f5'),
                  color: selectedLetter === letter ? 'white' : (hasVarieties ? '#4B164C' : '#ccc'),
                  fontSize: '0.9rem',
                  fontWeight: '500',
                  cursor: hasVarieties ? 'pointer' : 'default',
                  transition: 'all 0.2s'
                }}
                onMouseOver={e => {
                  if (hasVarieties && selectedLetter !== letter) {
                    e.currentTarget.style.borderColor = '#4B164C';
                    e.currentTarget.style.background = '#f0e6f0';
                  }
                }}
                onMouseOut={e => {
                  if (hasVarieties && selectedLetter !== letter) {
                    e.currentTarget.style.borderColor = '#e8e0e8';
                    e.currentTarget.style.background = 'white';
                  }
                }}
              >
                {letter}
              </button>
            );
          })}
        </div>
      </div>

      {/* Search Results Summary */}
      {(searchTerm || selectedLetter !== 'all') && (
        <div style={{ 
          marginBottom: '30px', 
          padding: '15px', 
          background: '#f0e6f0', 
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <p style={{ 
            color: '#4B164C', 
            fontSize: '1rem',
            margin: '0',
            fontWeight: '500'
          }}>
            {filteredVarieties.length} cépage{filteredVarieties.length > 1 ? 's' : ''} trouvé{filteredVarieties.length > 1 ? 's' : ''} 
            {searchTerm && ` pour "${searchTerm}"`}
            {selectedLetter !== 'all' && ` commençant par "${selectedLetter}"`}
          </p>
        </div>
      )}

      {/* Grape Varieties List */}
      <div style={{ marginBottom: '50px' }}>
        <h2 style={{ 
          fontSize: '1.8rem', 
          color: '#4B164C', 
          marginBottom: '30px',
          textAlign: 'center'
        }}>
          {searchTerm || selectedLetter !== 'all' ? 'Résultats de Recherche' : 'Tous les Cépages'}
        </h2>
        
        {Object.keys(groupedVarieties).length > 0 ? (
          Object.keys(groupedVarieties).sort().map(letter => (
            <div key={letter} style={{ marginBottom: '40px' }}>
              <h3 style={{ 
                fontSize: '2rem', 
                color: '#4B164C', 
                marginBottom: '20px',
                textAlign: 'center',
                fontWeight: '600'
              }}>
                {letter}
              </h3>
              
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', 
                gap: '20px' 
              }}>
                {groupedVarieties[letter].map((grape, index) => (
                  <div
                    key={index}
                    style={{
                      background: '#fff',
                      borderRadius: '12px',
                      border: '2px solid #e8e0e8',
                      padding: '20px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      transition: 'transform 0.2s, box-shadow 0.2s'
                    }}
                    onMouseOver={e => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.15)';
                    }}
                    onMouseOut={e => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                    }}
                  >
                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'flex-start',
                      marginBottom: '15px'
                    }}>
                      <h4 style={{ 
                        fontSize: '1.3rem', 
                        color: '#4B164C', 
                        margin: '0',
                        fontWeight: '600'
                      }}>
                        {grape.name}
                      </h4>
                      <span style={{
                        padding: '6px 12px',
                        background: grape.type === 'Rouge' ? '#4B164C' : '#f0e6f0',
                        color: grape.type === 'Rouge' ? 'white' : '#4B164C',
                        borderRadius: '12px',
                        fontSize: '0.8rem',
                        fontWeight: '500'
                      }}>
                        {grape.type}
                      </span>
                    </div>
                    
                    <div style={{ marginBottom: '12px' }}>
                      <p style={{ 
                        color: '#666', 
                        fontSize: '0.95rem',
                        margin: '0 0 8px 0'
                      }}>
                        <strong>Pays:</strong> {grape.country}
                      </p>
                      <p style={{ 
                        color: '#666', 
                        fontSize: '0.95rem',
                        margin: '0 0 8px 0'
                      }}>
                        <strong>Région:</strong> {grape.region}
                      </p>
                      <p style={{ 
                        color: '#666', 
                        fontSize: '0.9rem',
                        margin: '0',
                        fontStyle: 'italic',
                        lineHeight: '1.4'
                      }}>
                        <strong>Caractéristiques:</strong> {grape.characteristics}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        ) : (
          <div style={{ 
            textAlign: 'center', 
            padding: '40px', 
            background: '#f8f6fa', 
            borderRadius: '12px' 
          }}>
            <p style={{ 
              color: '#666', 
              fontSize: '1.1rem',
              margin: '0'
            }}>
              {searchTerm ? `Aucun cépage trouvé pour "${searchTerm}"` : 'Aucun cépage disponible'}
            </p>
          </div>
        )}
      </div>

      {/* Wine Style Categories */}
      <div style={{ marginBottom: '50px' }}>
        <h2 style={{ 
          fontSize: '1.8rem', 
          color: '#4B164C', 
          marginBottom: '30px',
          textAlign: 'center'
        }}>
          Styles de Cépages
        </h2>
        
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
          gap: '20px' 
        }}>
          {wineStyles.map((style, index) => (
            <div
              key={index}
              style={{
                background: '#fff',
                borderRadius: '12px',
                border: '2px solid #e8e0e8',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}
            >
              <h3 style={{ 
                fontSize: '1.3rem', 
                color: '#4B164C', 
                margin: '0 0 8px 0',
                fontWeight: '600'
              }}>
                {style.name}
              </h3>
              <p style={{ 
                color: '#666', 
                fontSize: '0.95rem',
                margin: '0 0 16px 0',
                lineHeight: '1.5'
              }}>
                {style.description}
              </p>
              
              <div style={{ marginBottom: '16px' }}>
                <h4 style={{ 
                  fontSize: '1rem', 
                  color: '#4B164C', 
                  margin: '0 0 8px 0',
                  fontWeight: '500'
                }}>
                  Exemples
                </h4>
                <div style={{ 
                  display: 'flex', 
                  flexWrap: 'wrap', 
                  gap: '6px' 
                }}>
                  {style.examples.map((example, idx) => (
                    <span
                      key={idx}
                      style={{
                        padding: '4px 8px',
                        background: '#f0e6f0',
                        borderRadius: '12px',
                        fontSize: '0.8rem',
                        color: '#4B164C'
                      }}
                    >
                      {example}
                    </span>
                  ))}
                </div>
              </div>
              
              <div>
                <h4 style={{ 
                  fontSize: '1rem', 
                  color: '#4B164C', 
                  margin: '0 0 8px 0',
                  fontWeight: '500'
                }}>
                  Caractéristiques
                </h4>
                <p style={{ 
                  color: '#666', 
                  fontSize: '0.9rem',
                  margin: '0',
                  lineHeight: '1.4'
                }}>
                  {style.characteristics}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Quick Links */}
      <div style={{ 
        padding: '30px', 
        background: '#f8f6fa', 
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <h3 style={{ 
          fontSize: '1.3rem', 
          color: '#4B164C', 
          marginBottom: '15px',
          fontWeight: '600'
        }}>
          Explorez Plus
        </h3>
        <div style={{ 
          display: 'flex', 
          flexWrap: 'wrap', 
          gap: '15px', 
          justifyContent: 'center' 
        }}>
          <Link
            to="/info/countries"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '12px 20px',
              background: '#4B164C',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              fontSize: '0.9rem',
              fontWeight: '500',
              transition: 'background 0.2s'
            }}
            onMouseOver={e => e.currentTarget.style.background = '#6d2c7a'}
            onMouseOut={e => e.currentTarget.style.background = '#4B164C'}
          >
            Pays Viticoles
            <CaretRight size={16} />
          </Link>
          <Link
            to="/info/regions"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '12px 20px',
              background: '#6d2c7a',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              fontSize: '0.9rem',
              fontWeight: '500',
              transition: 'background 0.2s'
            }}
            onMouseOver={e => e.currentTarget.style.background = '#8a4a8a'}
            onMouseOut={e => e.currentTarget.style.background = '#6d2c7a'}
          >
            Régions
            <CaretRight size={16} />
          </Link>
          <Link
            to="/info/styles"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '12px 20px',
              background: '#8a4a8a',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              fontSize: '0.9rem',
              fontWeight: '500',
              transition: 'background 0.2s'
            }}
            onMouseOver={e => e.currentTarget.style.background = '#a06aa0'}
            onMouseOut={e => e.currentTarget.style.background = '#8a4a8a'}
          >
            Styles de Vin
            <CaretRight size={16} />
          </Link>
          <Link
            to="/info"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '12px 20px',
              background: '#f0e6f0',
              color: '#4B164C',
              textDecoration: 'none',
              borderRadius: '8px',
              fontSize: '0.9rem',
              fontWeight: '500',
              border: '2px solid #4B164C',
              transition: 'all 0.2s'
            }}
            onMouseOver={e => {
              e.currentTarget.style.background = '#4B164C';
              e.currentTarget.style.color = 'white';
            }}
            onMouseOut={e => {
              e.currentTarget.style.background = '#f0e6f0';
              e.currentTarget.style.color = '#4B164C';
            }}
          >
            Guide du Vin
            <CaretRight size={16} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GrapeVarietiesOverviewPage; 